import React, { FC } from 'react';

import toast, { Toast } from 'react-hot-toast';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';

import { showCriticalMissedNotification } from '@pharmaplan/common';
import { ReactComponent as Critical } from '../../../assets/svg/missedCritical.svg';
import genericClasses from '../../../theme/GenericClasses';
import CustomButton from '../../common/CustomButton';
import strings from '../../../localization';

import styles from './styles';
import { useAppDispatch } from '../../../hooks/useAppDispatch';

interface IMissedCriticalNotification {
  toastParams: Toast;
  onClick: () => void;
}

const MissedCriticalNotification: FC<IMissedCriticalNotification> = ({
  toastParams,
  onClick,
}) => {
  const dispatch = useAppDispatch();
  const handleView = () => {
    toast.dismiss(toastParams.id);
    dispatch(showCriticalMissedNotification(false));
    onClick?.();
  };

  return (
    <Box sx={[styles.container, genericClasses.flex, genericClasses.center]}>
      <Box sx={styles.labelContainer}>
        <Critical />
        <Typography sx={styles.label}>
          {strings.youMissedImportantUpdates}
        </Typography>
      </Box>
      <Box>
        <CustomButton
          customButtonStyle={styles.viewButton}
          label={strings.formatString(strings.view, '') as string}
          onClick={handleView}
        />
      </Box>
    </Box>
  );
};

export default MissedCriticalNotification;
